import { tv } from 'tailwind-variants';

export const HeaderWrapper = tv(
  {
    base: 'flex flex-row items-center',
    variants: {
      type: {
        title: 'justify-between',
        noTitle: 'justify-end'
      }
    },
  },
);
